export default __webpack_public_path__ + "static/media/BigGold-Check.97b514ca.png";